import { ContentLoader } from "@rio-cloud/rio-uikit";
import { VehicleSupport } from "../../../types";
import moment from 'moment';

type VehicleDataItemProps = {
    title: string;
    value?: string | number | boolean;
    isLoading: boolean;
};

interface Props {
    data: VehicleSupport | null;
    isLoading: boolean;
}

const VehicleDataItem = ({ title, value, isLoading }: VehicleDataItemProps) => {
    return (
        <div className="flex items-start justify-between gap-4">
            <span className="text-color-dark text-size-14">{title}</span>

            {isLoading ? (
                <div style={{ width: 80, height: 20, borderRadius: 0, overflow: 'hidden' }}>
                    <ContentLoader className="width-100pct height-100pct" />
                </div>
            ) : (
                <span className="text-color-darker text-size-16 text-right">
                    {value || '-'}
                </span>
            )}
        </div>
    );
};

const formatDate = (date?: string, format = "DD/MM/YYYY") => {
    if (!date) {
        return '-'
    };

    return moment(date).format(format)
}

const formatBooleanValue = (value?: boolean | null): string => {
  if (typeof value !== 'boolean') {
    return '-';
  }

  return value ? 'Sim' : 'Não';
};

const VehicleData = ({ data, isLoading }: Props) => {
    const vehicleData = [
        {
            title: 'Proprietário do Veículo',
            value: data?.vehicleOwner,
        },
        {
            title: 'Modelo',
            value: data?.model,
        },
        {
            title: 'Chassi',
            value: data?.chassis,
        },
        {
            title: 'Placa',
            value: data?.licensePlate,
        },
        {
            title: 'Descrição Cor',
            value: data?.color,
        },
        {
            title: 'Tipo Implemento',
            value: data?.implementType,
        },
        {
            title: 'Data Produção',
            value: formatDate(data?.productionDate),
        },
        {
            title: 'Data Faturamento',
            value: formatDate(data?.billingDate),
        },
        {
            title: 'Data entrega TS',
            value: formatDate(data?.tsDeliveryDate),
        },
        {
            title: 'Dealer Responsável',
            value: data?.responsibleDealer,
        },
        {
            title: 'Fim garantia 0',
            value: formatDate(data?.warrantyEnd),
        },
        {
            title: 'Fim garantia adicional (B)',
            value: formatDate(data?.additionalWarrantyEnd),
        },
        {
            title: 'Numero contrato manutenção 1',
            value: data?.contractNumber,
        },
        {
            title: 'Modalidade contrato manutenção 1',
            value: data?.contractModality,
        },
        {
            title: 'Status veículo contrato 1',
            value: data?.vehicleStatus,
        },
        {
            title: 'Início Contrato Manutenção 1',
            value: formatDate(data?.contractStart),
        },
        {
            title: 'Fim Contrato Manutenção 1',
            value: formatDate(data?.contractEnd),
        },
        {
            title: 'Limite Km Contrato Manutenção 1',
            value: `${data?.kmLimit || '-'}`,
        },
        {
            title: 'Inicio Garantia Especial (A)',
            value: formatDate(data?.specialWarrantyStart),
        },
        {
            title: 'Fim Garantia Especial (A)',
            value: formatDate(data?.specialWarrantyEnd),
        },
        {
            title: 'Adesão 1 Garantia Especial (A)',
            value: `${data?.firstSpecialWarrantyAdhesion || '-'}`,
        },
        {
            title: 'Tipo cobertura adesão 1 Garantia adicional (B)',
            value: data?.firstAdditionalWarrantyCoverageTypeAdhesion,
        },
        {
            title: 'Adesão 2 garantia especial (A)',
            value: `${data?.secondSpecialWarrantyAdhesion || '-'}`,
        },
        {
            title: 'Tipo Cobertura Adesão 2 Garantia Especial (A)',
            value: data?.secondAdditionalWarrantyCoverageTypeAdhesion,
        },
        {
            title: 'Campanhas Pendentes',
            value: data?.campaigns,
        },
        {
            title: 'Última atualização',
            value: formatDate(data?.updatedAt, "DD/MM/YYYY HH:mm"),
        },
        {
            title: 'Consultar jurídico',
            value: formatBooleanValue(data?.consultLegal),
        },
        {
            title: 'Veículo impedido',
            value: formatBooleanValue(data?.vehicleBlocked),
        },
        {
            title: 'Garantia',
            value: formatBooleanValue(data?.hasWarranty),
        },
        {
            title: 'Possui garantia VolksConfia',
            value: formatBooleanValue(data?.hasVolksConfiaWarranty),
        },
        {
            title: 'Inicio garantia VolksConfia',
            value: formatDate(data?.volksConfiaWarrantyStart),
        },
        {
            title: 'Fim garantia VolksConfia',
            value: formatDate(data?.volksConfiaWarrantyEnd),
        },
    ];

    return (
        <div className="border rounded width-100pct height-100pct padding-15">
            <div className="margin-bottom-15">
                <span className="text-size-16 text-medium ">
                    Dados do veículo
                </span>
            </div>

            <div className="display-flex flex-column">
                {vehicleData.map(item => (
                    <VehicleDataItem
                        key={item.title}
                        title={item.title}
                        value={item.value}
                        isLoading={isLoading}
                    />
                ))}
            </div>
        </div>
    );
};

export default VehicleData;